import React from 'react';

function MyBriefsEmptyState() {
  return (
    <div className="my-briefs-empty-state" data-testid="my-briefs-empty-state">
      <div className="my-briefs-empty-illustration" aria-hidden="true">
        <div className="my-briefs-empty-illustration-bg" />
        <div className="my-briefs-empty-illustration-card">
          <div className="my-briefs-empty-illustration-line short" />
          <div className="my-briefs-empty-illustration-line" />
          <div className="my-briefs-empty-illustration-line long" />
        </div>
        <div className="my-briefs-empty-illustration-pill" />
      </div>
      <p className="my-briefs-empty-title">You don’t have any saved drafts yet</p>
    </div>
  );
}

export default MyBriefsEmptyState;
